
import { type NavItem } from '@/shell/nav/navIcons'

export const NAV_DASH: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: 'dashboard', end: true, tooltip: 'Overview of activity, recent modules, and org health' },
  { to: '/integrations', label: 'Guides & Integrations', icon: 'integrations', tooltip: 'Step-by-step guides for Terraform, GitHub Actions, GitLab CI, and Pipeline Trust' },
]

// NAV_ARTEFACTS and NAV_GOVERNANCE are now dynamic - defined in Layout()
// because they depend on having at least one org selected
